import { atom } from "jotai";
import { Node } from "reactflow";
import { NodeData } from "../types";
import { filterByZapNodes } from "../utils";
import { nodesAtom } from "./nodesAtom";

export const zapNodesAtom = atom((get) => {
  const nodes: Node<NodeData>[] = get(nodesAtom);
  return filterByZapNodes(nodes);
});

zapNodesAtom.debugLabel = "zapNodesAtom";
